module.exports = __webpack_public_path__ + "static/media/photobook-asanov.f625b0fa.jpg";